import { useEffect, useRef, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Headphones, Loader2, Square } from "lucide-react";

export function LiaBriefingButton({ estId }) {
  const [state, setState] = useState("idle"); const audio = useRef(null);
  useEffect(() => () => { audio.current?.pause(); if (audio.current?.src) URL.revokeObjectURL(audio.current.src); }, []);
  const stop = () => { audio.current?.pause(); setState("idle"); };
  const play = async () => {
    if (state === "playing") return stop();
    setState("loading");
    try {
      const { data } = await api.post(`/staffing/${estId}/lia-briefing/speak`, null, { responseType: "blob" });
      const a = new Audio(URL.createObjectURL(data)); audio.current = a; a.onended = () => setState("idle"); await a.play(); setState("playing");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Lecture impossible"); setState("idle"); }
  };
  return <button onClick={play} title={state === "playing" ? "Arrêter" : "Écouter le briefing de la semaine"} className={`p-1.5 rounded-lg hover:bg-white/10 ${state === "playing" ? "text-indigo-300" : ""}`} data-testid="lia-panel-briefing">{state === "loading" ? <Loader2 className="w-4 h-4 animate-spin" /> : state === "playing" ? <Square className="w-4 h-4" /> : <Headphones className="w-4 h-4" />}</button>;
}
